"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createUsersApi = void 0;
var _react = require("@reduxjs/toolkit/query/react");
var _objects = require("../utilities/objects");
const createUsersApi = _ref => {
  let {
    baseUrl,
    slice,
    tokenName
  } = _ref;
  return (0, _react.createApi)({
    reducerPath: 'usersApi',
    baseQuery: (0, _react.fetchBaseQuery)({
      baseUrl,
      credentials: 'include',
      prepareHeaders: (headers, _ref2) => {
        var _getState$slice;
        let {
          getState
        } = _ref2;
        const token = (_getState$slice = getState()[slice]) === null || _getState$slice === void 0 ? void 0 : _getState$slice[tokenName];
        if (token) {
          headers.set('Authorization', `Bearer ${token}`);
        }
        return headers;
      }
    }),
    endpoints: builder => ({
      changeEmail: builder.mutation({
        query: body => ({
          body,
          method: 'POST',
          url: '/change-email'
        }),
        transformResponse: response => (0, _objects.toCamelCase)(response)
      }),
      changeEmailConfirm: builder.mutation({
        query: token => ({
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`
          },
          url: '/change-email-confirm'
        }),
        transformResponse: response => (0, _objects.toCamelCase)(response)
      }),
      deleteUser: builder.mutation({
        query: _ref3 => {
          let {
            body,
            asicsId
          } = _ref3;
          return {
            body,
            method: 'DELETE',
            url: `/users/${asicsId}`
          };
        },
        transformResponse: response => (0, _objects.toCamelCase)(response)
      }),
      emailExists: builder.query({
        query: email => ({
          method: 'GET',
          url: `/public/users?email=${email}`
        }),
        transformResponse: response => (0, _objects.toCamelCase)(response)
      }),
      forgotPassword: builder.mutation({
        query: body => ({
          body,
          method: 'POST',
          url: '/forgot-password'
        }),
        transformResponse: response => (0, _objects.toCamelCase)(response)
      }),
      getAdminChangelogs: builder.query({
        query: _ref4 => {
          let {
            params
          } = _ref4;
          return {
            url: '/admin-changelogs',
            params
          };
        },
        transformResponse: response => (0, _objects.toCamelCase)(response)
      }),
      getDeletedUserById: builder.query({
        query: _ref5 => {
          let {
            asicsId
          } = _ref5;
          return {
            url: `/users-deleted/${asicsId}`
          };
        },
        transformResponse: response => (0, _objects.toCamelCase)(response)
      }),
      getSupportedCountries: builder.query({
        query: () => ({
          url: '/countries'
        }),
        transformResponse: response => (0, _objects.toCamelCase)(response)
      }),
      getUserById: builder.query({
        query: _ref6 => {
          let {
            asicsId,
            deleted
          } = _ref6;
          return {
            url: `/${deleted ? 'soft-deleted-' : ''}users/${asicsId}`
          };
        },
        transformResponse: response => (0, _objects.toCamelCase)(response)
      }),
      getUserInfo: builder.query({
        query: () => ({
          keepUnusedDataFor: 60 * 60 * 24,
          url: '/userinfo'
        }),
        transformResponse: response => (0, _objects.toCamelCase)(response)
      }),
      getUsers: builder.query({
        query: _ref7 => {
          let {
            params
          } = _ref7;
          return {
            url: '/users',
            params
          };
        },
        transformResponse: response => (0, _objects.toCamelCase)(response)
      }),
      registerUser: builder.mutation({
        query: _ref8 => {
          let {
            body,
            headers
          } = _ref8;
          return {
            body,
            headers,
            method: 'POST',
            url: '/users'
          };
        },
        transformResponse: response => (0, _objects.toCamelCase)(response)
      }),
      removeSuspiciousFlag: builder.query({
        query: _ref9 => {
          let {
            asicsId
          } = _ref9;
          return {
            method: 'DELETE',
            url: `/users/suspicious/${asicsId}`
          };
        },
        transformResponse: response => (0, _objects.toCamelCase)(response)
      }),
      restoreUser: builder.query({
        query: _ref10 => {
          let {
            asicsId
          } = _ref10;
          return {
            method: 'DELETE',
            url: `/soft-deleted-users/${asicsId}`
          };
        },
        transformResponse: response => (0, _objects.toCamelCase)(response)
      }),
      updateUser: builder.mutation({
        query: _ref11 => {
          let {
            asicsId,
            body,
            token = null
          } = _ref11;
          return {
            body,
            headers: {
              ...(token && {
                Authorization: `Bearer ${token}`
              })
            },
            method: 'PATCH',
            url: `/users/${asicsId}`
          };
        },
        transformResponse: response => (0, _objects.toCamelCase)(response)
      })
    })
  });
};
exports.createUsersApi = createUsersApi;